import { CognitoUserPool } from 'amazon-cognito-identity-js';
import config from './aws-exports';
var poolData = {
    Region: config.REGION,
    UserPoolId: config.USER_POOL_ID,
    ClientId: config.USER_POOL_APP_CLIENT_ID,
};
export default new CognitoUserPool(poolData);
